import { render, staticRenderFns } from "./OlaForm.vue?vue&type=template&id=4ff6e2cd"
import script from "./OlaForm.vue?vue&type=script&lang=js"
export * from "./OlaForm.vue?vue&type=script&lang=js"
import style0 from "./OlaForm.vue?vue&type=style&index=0&id=4ff6e2cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports